import { required, minLength } from 'vuelidate/lib/validators'

export default {
  mittelgeber: {
    name: { required, minLength: minLength(1) }
  }
  // foerderkennzeichen: { required }
}



// WEBPACK FOOTER //
// ./src/validation/Foerderung.js